(function(){
  function euros(n){return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR',maximumFractionDigits:0}).format(n||0)}
  function initCalculator(root){
    var ducks=root.querySelector('[data-ducks]');
    var price=root.querySelector('[data-price]');
    var cost=root.querySelector('[data-cost]');
    var outDucks=root.querySelector('[data-out-ducks]');
    var outPrice=root.querySelector('[data-out-price]');
    var outRevenue=root.querySelector('[data-out-revenue]');
    var outCosts=root.querySelector('[data-out-costs]');
    var outCost=root.querySelector('[data-out-cost]');
    var outNet=root.querySelector('[data-out-net]');
    function update(){
      var d=parseInt(ducks && ducks.value || 0,10);
      var p=parseFloat(price && price.value || 0);
      var c=parseFloat(cost && cost.value || 0);
      var revenue=d*p;
      var costs=d*c;
      var net=revenue-costs;
      if(outDucks) outDucks.textContent=new Intl.NumberFormat('fr-FR').format(d);
      if(outPrice) outPrice.textContent=euros(p);
      if(outRevenue) outRevenue.textContent=euros(revenue);
      if(outCost) outCost.textContent=euros(c);
      if(outCosts) outCosts.textContent=euros(costs);
      if(outNet) outNet.textContent=euros(net);
    }
    [ducks,price,cost].forEach(function(el){ if(el) el.addEventListener('input',update); });
    update();
  }
  function boot(){document.querySelectorAll('[data-duckrace-roi]').forEach(initCalculator)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
